import React, { useState } from 'react';
import useBrowserTranslateObserver from 'hooks/useBrowserTranslateObserver';

const GlobalLayout = ({ children }) => {
  const [translated, setTranslated] = useState(false);

  useBrowserTranslateObserver(() => {
    // function if detected
    if (!translated) setTranslated(true);
  }, () => {
    // function if not detected
    if (translated) setTranslated(false);
  });

  return translated ? <div>
    <div className="d-flex justify-content-center align-items-center vh-100 p-5">
      <h4 className="text-break">Die Browser-Übersetzung wird nicht unterstützt. Bitte deaktivieren Sie sie, um die App weiterhin nutzen zu können.</h4>
    </div>
  </div> : children;
};

export default GlobalLayout;
